import { useState, useEffect } from "react";
import Sidebar from "../components/Sidebar";
import { Link } from "react-router-dom";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import ProfileLoader from "../components/ProfileLoader";
import { fetchApi, sendApi } from "../apis/Index";
import { toast } from "react-hot-toast";

const EditProfile = () => {
  const [side, setSide] = useState(false);
  const [user, setUser] = useState(null);
  const [edit, setEdit] = useState(false);
  const [load, setLoad] = useState(true); // Changed to true initially
  const [update, setUpdate] = useState(false);
  const [unauthorized, setUnauthorized] = useState(false);

  useEffect(() => {
    const profileApi = "https://wittynailtip.com/backend/profile.php";
    async function fetchData() {
      setLoad(true);
      try {
        const response = await fetch(profileApi, {
          credentials: "include",
        });
        const result = await response.json(); // Parse the JSON response

        if (result.status === "unauthorized") {
          setUnauthorized(true);
          toast.error(result.message);
        } else if (result.status) {
          setUser(result.data);
        } else {
          toast.error(result.message);
          setUser(null);
        }
        setLoad(false);
      } catch (error) {
        console.error(error);
        setLoad(false);
      }
    }
    fetchData();
  }, []);

  const UpdateProfile = async (e) => {
    setUpdate(true);
    e.preventDefault();
    const full_name = e.target.name.value || user?.full_name;
    const username = user?.username;
    const phone_number = e.target.phone.value || user?.phone_number;
    const email = user?.email;
    const billing_address = e.target.address.value || user?.billing_address;

    const updatedProfile = {
      name: full_name,
      username: username,
      number: phone_number,
      email: email,
      billing: billing_address,
    };
    const updateProfileApi =
      "https://wittynailtip.com/backend/edit-profile.php";
    try {
      const result = await sendApi(updatedProfile, updateProfileApi);
      if (result.data.success) {
        toast.success(result.data.message);
      } else {
        toast.error(result.data.message);
      }
      setUpdate(false);
      setEdit(false);
    } catch (error) {
      console.error(error.message);
    }
  };

  const Logout = async (e) => {
    e.preventDefault();
    const logoutApi = "https://wittynailtip.com/backend/logout.php";
    try {
      const result = await fetchApi(logoutApi);
      if (result.data.success) {
        toast.success("Logout successful");
        window.location.reload();
        console.log(result);
      } else {
        console.log(result.data.message || result.data.error);
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="w-full md:flex justify-start items-start overflow-x-hidden font-jost">
      <div className="px-3 h-14 flex justify-between items-center lg:hidden">
        <button
          type="button"
          className="cursor-pointer p-2"
          onClick={() => setSide(!side)}
        >
          <div className="w-5 h-1 bg-black mb-[2px]"></div>
          <div className="w-5 h-1 bg-[#FFB7CF] ml-1"></div>
        </button>
      </div>
      <div className="hidden lg:block">
        <Sidebar open={true} noSearch={true} />
      </div>
      <div className="">
        <Sidebar open={side} noSearch={true} />
      </div>

      <div className="profile-outer w-full md:py-10 py-6 px-5 mx-auto lg:ml-[25%] z-[90] bg-gray-50 min-h-screen">
        {load ? (
          <ProfileLoader />
        ) : unauthorized ? (
          <div className="flex items-center justify-center h-[80vh] w-full">
            <div className="text-center bg-white p-10 rounded-3xl shadow-sm max-w-md w-full">
              <div className="w-20 h-20 bg-[#fff1f5] rounded-full flex items-center justify-center mx-auto mb-6">
                <svg className="w-10 h-10 text-[#FFB7CF]" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"></path>
                </svg>
              </div>
              <h2 className="text-2xl font-bold text-gray-900 mb-3">Access Denied</h2>
              <p className="text-gray-500 mb-8">You need to log in to view and edit your profile settings.</p>
              <Link to="/auth?login=true">
                <button className="bg-gray-900 hover:bg-black text-white px-8 py-3 rounded-full font-medium transition-all shadow-lg hover:-translate-y-1 w-full">
                  Sign In
                </button>
              </Link>
            </div>
          </div>
        ) : (
          <div className="profile-inner max-w-4xl mx-auto space-y-8">
            <div className="flex justify-between items-center border-b border-gray-200 pb-4">
              <h3 className="font-bold text-3xl text-gray-900">My Profile</h3>
            </div>
            
            <div className="bg-white rounded-3xl shadow-sm p-8 flex flex-col md:flex-row gap-8 items-start">
              <div className="pic-btn flex flex-col items-center space-y-6 md:w-1/3">
                <div className="relative">
                  <div className="img-box rounded-full h-40 w-40 overflow-hidden border-4 border-white shadow-xl flex justify-center items-center flex-shrink-0 bg-gray-50">
                    <img
                      alt="logo"
                      src="/logo.webp"
                      className="w-full h-full object-cover"
                    />
                  </div>
                  {edit && (
                    <button className="absolute bottom-2 right-2 bg-[#FFB7CF] text-white p-2 rounded-full shadow-lg hover:bg-[#ff9ebc] transition-colors">
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z"></path><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 13a3 3 0 11-6 0 3 3 0 016 0z"></path></svg>
                    </button>
                  )}
                </div>

                <div className="btn flex flex-col w-full gap-3 font-medium">
                  {!edit && (
                    <button
                      type="button"
                      className="bg-gray-900 hover:bg-black text-white py-3 rounded-full text-base transition-all shadow-md hover:shadow-lg w-full"
                      onClick={() => setEdit(true)}
                    >
                      Edit Profile
                    </button>
                  )}
                  {!edit && (
                    <button
                      type="button"
                      className="bg-red-50 hover:bg-red-100 text-red-600 py-3 rounded-full text-base transition-colors w-full"
                      onClick={(e) => Logout(e)}
                    >
                      Sign Out
                    </button>
                  )}
                </div>
              </div>

              <div className="profile-form md:w-2/3 w-full">
                <form
                  action=""
                  className="profile-details space-y-6 w-full"
                  onSubmit={(e) => UpdateProfile(e)}
                >
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div className="profile-name">
                      <label htmlFor="name" className="block text-gray-700 font-semibold mb-2 text-sm">
                        Full Name
                      </label>
                      <input
                        disabled={!edit}
                        type="text"
                        name="name"
                        id="name"
                        className={`h-12 w-full border rounded-xl px-4 text-base outline-none transition-all ${edit ? 'border-gray-300 focus:border-[#FFB7CF] focus:ring-2 focus:ring-[#FFB7CF]/20 bg-white text-gray-900' : 'border-gray-100 bg-gray-50 text-gray-500 cursor-not-allowed'}`}
                        defaultValue={user?.full_name}
                      />
                    </div>

                    <div className="profile-uname">
                      <label htmlFor="uname" className="block text-gray-700 font-semibold mb-2 text-sm flex justify-between items-center">
                        Username <span className="text-gray-400 text-xs font-normal">Cannot be changed</span>
                      </label>
                      <input
                        disabled
                        type="text"
                        name="uname"
                        id="uname"
                        className="h-12 w-full border border-gray-100 rounded-xl px-4 text-base outline-none bg-gray-50 text-gray-500 cursor-not-allowed"
                        defaultValue={user?.username}
                      />
                    </div>
                  </div>

                  <div className="profile-email">
                    <label htmlFor="email" className="block text-gray-700 font-semibold mb-2 text-sm flex justify-between items-center">
                      Email Address <span className="text-gray-400 text-xs font-normal">Contact support to change</span>
                    </label>
                    <input
                      disabled
                      type="text"
                      name="email"
                      id="email"
                      className="h-12 w-full border border-gray-100 rounded-xl px-4 text-base outline-none bg-gray-50 text-gray-500 cursor-not-allowed"
                      defaultValue={user?.email}
                    />
                  </div>

                  <div className="profile-phone">
                    <label htmlFor="phone" className="block text-gray-700 font-semibold mb-2 text-sm">
                      Phone Number
                    </label>
                    <input
                      disabled={!edit}
                      type="text"
                      name="phone"
                      id="phone"
                      className={`h-12 w-full border rounded-xl px-4 text-base outline-none transition-all ${edit ? 'border-gray-300 focus:border-[#FFB7CF] focus:ring-2 focus:ring-[#FFB7CF]/20 bg-white text-gray-900' : 'border-gray-100 bg-gray-50 text-gray-500 cursor-not-allowed'}`}
                      defaultValue={user?.phone_number}
                    />
                  </div>

                  <div className="profile-address">
                    <label htmlFor="address" className="block text-gray-700 font-semibold mb-2 text-sm">
                      Billing Address
                    </label>
                    <textarea
                      disabled={!edit}
                      name="address"
                      id="address"
                      rows="3"
                      className={`w-full border rounded-xl p-4 text-base outline-none transition-all resize-none ${edit ? 'border-gray-300 focus:border-[#FFB7CF] focus:ring-2 focus:ring-[#FFB7CF]/20 bg-white text-gray-900' : 'border-gray-100 bg-gray-50 text-gray-500 cursor-not-allowed'}`}
                      defaultValue={user?.billing_address}
                    ></textarea>
                  </div>

                  {edit && (
                    <div className="submit-btns pt-4 flex justify-end gap-3 text-white font-medium border-t border-gray-100">
                      <button
                        type="button"
                        onClick={() => setEdit(false)}
                        className="px-6 py-3 rounded-full text-gray-600 bg-gray-100 hover:bg-gray-200 transition-colors"
                      >
                        Cancel
                      </button>
                      <button
                        type="submit"
                        disabled={update}
                        className="bg-[#FFB7CF] hover:bg-[#ff9ebc] px-8 py-3 rounded-full text-white flex gap-x-2 items-center justify-center transition-colors shadow-md disabled:opacity-70"
                      >
                        {update ? 'Saving...' : 'Save Changes'}
                        <AiOutlineLoading3Quarters className={`animate-spin ${update ? "block" : "hidden"}`} />
                      </button>
                    </div>
                  )}
                </form>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default EditProfile;
